import * as areas from "./areas";

export default Object.freeze({ areas });
